export default __webpack_public_path__ + "static/media/011-ice cream.9936b8b9.svg";